import { render, staticRenderFns } from "./JCA.vue?vue&type=template&id=5dc00846&scoped=true"
import script from "./JCA.vue?vue&type=script&lang=js"
export * from "./JCA.vue?vue&type=script&lang=js"
import style0 from "./JCA.vue?vue&type=style&index=0&id=5dc00846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc00846",
  null
  
)

export default component.exports